import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import createSagaMiddleware from "redux-saga";
import thunk from "redux-thunk";
import logger from "redux-logger";
import { identify, peopleInc, track } from "./store/mixpanel";
import { sdkIsReady, getContext } from "./utils/facebookWebview";
import { isKik } from "./utils/platform";
import createStore from "./store";
import { bootSagas, bootStore } from "./store/boot";
import App from "./App";

const preloadedState = window.__PRELOADED_STATE__;
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();
const middlewares =
  process.env.NODE_ENV !== "development"
    ? applyMiddleware(thunk, sagaMiddleware)
    : applyMiddleware(thunk, logger, sagaMiddleware);
const enhancers = composeEnhancers(middlewares);
const store = createStore(preloadedState, enhancers);
const context = {};

bootSagas(sagaMiddleware);

const render = () => {
  ReactDOM.render(
    <Router basename={process.env.REACT_APP_BASE_NAME || ""} context={context}>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>,
    document.getElementById("root")
  );
};

render();
console.time("INIT PLATFORM");
console.time("INIT PLATFORM ERR");

if (isKik()) {
  initializeKik().catch(handleError);
} else {
  initializeFb().catch(handleError);
}

function initializeFb() {
  return sdkIsReady()
    .then(() => getContext(process.env.REACT_APP_MESSENGER_APP_ID))
    .then(({ psid }) => psid)
    .then(loadApplication);
}

function initializeKik() {
  return Promise.resolve()
    .then(() => window.kik.message.chatId)
    .then(loadApplication);
}

function loadApplication(user_id) {
  console.timeEnd("INIT PLATFORM");
  store.dispatch(identify(user_id));
  store.dispatch(track({ name: "Open Settings Webview" }));
  store.dispatch(peopleInc("webview_open_count"));
  return bootStore(store, { user_id });
}

function renderErr(obj) {
  const parent = document.getElementById("root").parentElement;
  const element = document.createElement("pre");
  element.innerHTML = JSON.stringify(obj, null, 2);
  parent.appendChild(element);
}

function handleError(err) {
  console.timeEnd("INIT PLATFORM ERR");
  console.log(err);
  if (process.env.NODE_ENV === "development") {
    loadApplication("1797419833666351");
  } else {
    window.location.href = "https://blinkthebee.com";
  }
}



// WEBPACK FOOTER //
// ./src/index.js